import { datadogRum } from '@datadog/browser-rum';
import { getConfig } from 'helpers/Config';

export const initDatadog = () => {
    const environment = getConfig('ENVIRONMENT');
    const mapping = {
        prod: 'live',
        staging: 'preview',
    };
    const overrideEnvironment = mapping[environment] || environment;

    if (overrideEnvironment !== 'preview' && overrideEnvironment !== 'live') return;

    datadogRum.init({
        applicationId: getConfig('DD_APPLICATION_ID'),
        clientToken: getConfig('DD_CLIENT_TOKEN'),
        site: 'datadoghq.eu',
        service: getConfig('DD_SERVICE'),
        version: getConfig('DD_VERSION'),
        env: overrideEnvironment,
        allowedTracingUrls: [getConfig('API_URL')],
        sessionSampleRate: 10,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask',
    });

    datadogRum.startSessionReplayRecording();
};
